import { Anchor } from '../../../../shared/Anchor';
import EastOutlinedIcon from '@mui/icons-material/EastOutlined';
import { NavigationLink } from '../../types';
import styles from './index.module.scss';

export interface NavigationProps {
  links: NavigationLink[];
}

export default function Navigation(props: NavigationProps) {
  const { links } = props;

  return (
    <nav className={styles.nav}>
      <ul className={styles.navList}>
        {links.map((link) => (
          <li
            key={link.href}
            className={styles.navItem}
            tabIndex={link.tabIndex}
          >
            <Anchor
              to={link.href}
              openInNewTab={true}
              className={styles.navLink}
            >
              <div className={styles.linkLabel}>
                <span>{link.label}</span>
                <div className={styles.linkIcon}>
                  <EastOutlinedIcon fontSize="inherit" color="inherit" />
                </div>
              </div>
              <span className={styles.linkDescription}>{link.description}</span>
            </Anchor>
          </li>
        ))}
      </ul>
    </nav>
  );
}
